<template>
  <span>
    <AhaButton
      variant="white"
      v-tooltip="$i18nPresenter.t('Interact with this presentation to test it as a participant.')"
      @click="openParticipantView()"
      class="participant-button-has-animation"
      :disabled="isDisableEditPresentation"
    >
      <div class="participant-icon">
        <i class="fas fa-mobile-alt" />
      </div>
      <span>{{ $i18nPresenter.t('Participant view') }}</span>
    </AhaButton>

    <div
      v-if="$store.state.showLiveAudienceDemo && !$store.getters.isPresenting"
      class="live-demo-audience"
      :class="{'disable-drag': disableDrag}"
    >
      <div class="iphone">
        <div class="close-demo" @click="closeParticipantView()">
          <i class="fas fa-times" />
        </div>

        <div class="iphone-top">
          <span class="sensor" />
          <span class="speaker" />
        </div>

        <div class="iphone-screen">
          <div class="overlay-draging"></div>
          <div v-if="slideActive.type === 'pickAnswer'" class="iframe-audience__quiz">
            <p v-html="$t('participantViewQuizContent')"></p>
          </div>
          <iframe
            :src="audienceLink"
            width="100%"
            height="100%"
            v-if="audienceLink && slideActive.type !== 'pickAnswer'"
            style="box-shadow: none; border: none; margin-top: -1px;"
            :class="{'loaded': isLoaded}"
            class="iframe-audience"
          >
            <p>{{ $i18nPresenter.t('Your browser does not support iframes.') }}</p>
          </iframe>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import { mapState } from 'vuex'

import Utils from '@/util'
import constants from '@/constant'

// configs
import configs from '@/config'

export default {
  props: {
    disableDrag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      audienceLink: '',
      isLoaded: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    participantViewQuizContent() {
      return 'Currently, quizzes don’t work in Participant View. To test, press <strong>Present</strong> on the editor and <strong>join the quiz</strong> with your phone.'
    },
  },
  mounted() {
    let audienceLink = `${configs.audienceDomain}/${this.presentation.uniqueAccessCode}`

    if (this.$store.state.plan.type === 'white-label' && this.currentUser.whiteLabelLink) {
      audienceLink = `https://${this.currentUser.whiteLabelLink}/${this.presentation.uniqueAccessCode}`
    }

    this.audienceLink = `${audienceLink}?fromIframe=true`

    setTimeout(() => {
      this.isLoaded = true
    }, 1000)
  },
  methods: {
    openParticipantView() {
      this.$store.state.showLiveAudienceDemo = true
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Participant View > Open', this.presentation.id)
    },
    closeParticipantView() {
      this.$store.state.showLiveAudienceDemo = false
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Participant View > Close', this.presentation.id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.iframe-audience {
  opacity: 0;

  &.loaded {
    opacity: 1;
  }
}

.iframe-audience__quiz {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80%;
  line-height: 1.5;
  padding: 0 16px;
  font-size: 1em;
}

.close-demo,
.setting {
  position: absolute;
  right: -40px;
  background-color: #000;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  top: -10px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid #999;

  &:hover {
    background-color: #fff;
    color: #000;
  }
}

.setting {
  top: 110px;
}

.overlay-draging {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.live-demo-audience {
  position: fixed;
  top: -50px;
  right: 200px;
  z-index: 11;
  -webkit-transform: scale(0.8);
  transform: scale(0.8);

  &.draging {
    .overlay-draging {
      display: block;
    }
  }
}

*,
*:after,
*:before {
  box-sizing: border-box;
}

body {
  background-image: url("http://androidcentral.us/wp-content/uploads/2014/06/low-poly-texture-18.png?541271");
}

.iphone {
  box-shadow: 4px 4px 22px rgba(0,0,0,0.2);
  border: 2px solid #999;
  background: #f8f8f8;
  padding: 15px 12px;
  border-radius: 50px;
  height: 757px;
  width: 423px;
  position: relative;
  margin: 0 auto;
}

.iphone-top {
  padding: 5px 110px 18px;
  position: relative;

  .speaker {
    display: block;
    width: 70px;
    height: 6px;
    margin: 0 auto;
    border-radius: 6px;
    background: #ddd;
  }

  .camera {
    display: block;
    margin: 0 auto;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-bottom: 13px;
    background: #ddd;
  }

  .sensor {
    display: block;
    width: 15px;
    height: 15px;
    float: left;
    background: #ddd;
    margin-top: -5px;
    border-radius: 50%;
  }
}

.top-bar,
.bottom-bar {
  display: block;
  width: 423px;
  height: 15px;
  border: {
    left: 5px solid #bbb;
    right: 5px solid #bbb;
  }
  position: absolute;
  left: -5px;
}

.top-bar {
  top: 65px;
}

.bottom-bar {
  bottom: 65px;
}

.iphone-screen {
  border: 1px solid #a9a9a9;
  height: 655px;
  width: 375px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
  }
}

.buttons {
  .on-off,
  .up,
  .down,
  .sleep {
    display: block;
    background: #ccc;
    position: absolute;
    border-radius: 2px 0px 0px 2px;
  }
  .on-off {
    height: 40px;
    width: 3px;
    top: 100px;
    left: -8px;
  }

  .up,
  .down,
  .sleep {
    height: 60px;
    width: 5px;
    left: -10px;
  }

  .up {
    top: 170px;
  }

  .down {
    top: 250px;
  }

  .sleep {
    left: auto;
    right: -10px;
    top: 170px;
    border-radius: 0px 2px 2px 0px;
  }
}

.iphone-bottom {
  padding: 14px 0 0;

  span {
    display: block;
    margin: 0 auto;
    width: 68px;
    height: 68px;
    background: #ccc;
    border-radius: 50%;
    background: linear-gradient(
      135deg,
      #303233 0%,
      #b5b7b9 50%,
      #f0f2f2 69%,
      #303233 100%
    );
    position: relative;

    &:after {
      content: "";
      display: block;
      width: 60px;
      height: 60px;
      background: #fff;
      border-radius: 50%;
      position: absolute;
      left: 4px;
      top: 4px;
    }
  }
}

.live-demo-audience {
  &.disable-drag {
    position: unset;

    .close-demo {
      display: none;
    }
  }
}

.participant-button-has-animation {
  height: 36px;
  padding-left: 40px;
  position: relative;

  .participant-icon {
    position: absolute;
    left: 14px;
    background-color: rgba(51, 193, 115, 1);
    width: 24px;
    height: 24px;
    color: #fff;
    font-size: 17px;
    line-height: 28px;
    border-radius: 8px;
    i {
      position: relative;
      top: -1px;
    }
  }
}
</style>
